import React, { useEffect, useState } from "react";
import { useSession } from "../utils/Session";
import { useHistory, useLocation } from "react-router";
import { formatCount, objectToPath, pathToObject } from "../utils/Utils";
import { apiCall } from "../utils/Api";
import { Divider, Segmented, Select, Skeleton, Space, Tooltip, Spin, Typography, Layout, Table, Button } from "antd";
import { CloseOutlined, PicLeftOutlined, UnorderedListOutlined } from '@ant-design/icons';
import BrowseFilters from "./BrowseFilters";
import Paginate from "./Paginate";
import ProductSlider from "../content_creator/ProductSlider";
import List from "./List";
import moment from "moment-timezone";
import ListFav from "./ListFav";
import Renderer from "./Renderer";

export default function Catalogues() {

    const [session, setSession] = useSession();
    const [view, setView] = useState("details");
    const path = "/catalogues";
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const init = pathToObject(location.pathname);
    const [filters, setFilters] = useState(init);
    const [f, setF] = useState([]);
    const [results, setResults] = useState({ rows: [] });
    const [expanded, setExpanded] = useState([]);

    const [pagination, setPagination] = useState(() => {
        const offset = init?.o ?? 0;
        const limit = init?.l ?? 26;
        return {
            current: Math.floor(offset / limit) + 1,
            offset,
            pagesize: limit
        };
    });


    const count = (results.row_count < results.max_offset) ? results.row_count : results.max_offset;

    const fetchCatalogues = () => {

        setLoading(true);
        
        let _obj = pathToObject(location.pathname);

        apiCall("titlelist/getCatalogues", _obj, (_s, _r) => {
            if (_s) {
                setResults(_r);
                setFilters(_obj);
                setF(_r?.filter_info ?? []);

                const offset = _obj?.o ?? 0;
                const limit = _obj?.l ?? 26;

                setPagination({
                    current: Math.floor(offset / limit) + 1,
                    offset,
                    pagesize: limit
                })

            }
            setLoading(false);
        })
    }
    useEffect(fetchCatalogues, [location.pathname, session.logged_in]);

    const drawCatalogues = () => {
        return results.rows.map(item => {
            return (<List data={item} results={results} setResults={setResults} />)
        });
    }


    const drawChildTable = (_record) => {
        return (
            <>
                <div className="hideHover" style={{ "marginTop": "-7px", "marginLeft": "-8px", "marginRight": "-8px", "maxWidth": "1210px" }}>
                    <div style={{ "padding": "0 0px" }}>
                        <div style={{ "marginTop": "0px", "borderTop": "none", "backgroundColor": "#f1f1f1" }} className="closebar">
                            <Button style={{ "float": "right" }} onClick={() => setExpanded([])} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px", "color": "#111" }} /></small>} />
                            <br clear="both" />
                        </div>
                    </div>
                    <div style={{ "padding": "0px 8px", "backgroundColor": "#fff" }}>
                        <Renderer record_key={expanded} >
                            {(expanded && <List divider={false} is_catalogue={true} getLists={() => { }} setResults={setResults} results={results} data={_record} />)}
                        </Renderer>
                    </div>
                </div>
            </>
        )
    }


    const expandCell = (_data) => {
        if (!expanded.includes(_data.list_id)) {
            setExpanded([_data.list_id]);
        } else {
            setExpanded([]);
        }
    }

    const drawCataloguesList = () => {

        const columns = [

            // {
            //     title: <small>&nbsp;&nbsp;Fav</small>, dataIndex: 'is_starred', key: 'is_starred', render: (e, f) => {

            //         return (<ListFav list={f} results={results} setResults={setResults} getLists={() => { }} />);
            //     }
            // },
            {
                title: <small>List name</small>, dataIndex: 'name', key: 'name', render: (e, f) => {
                    return (e) ? <a onClick={() => expandCell(f)}>{e}</a> : <a onClick={() => expandCell(f)}>Unnamed</a>;
                }
            },
            {
                title: <small>Vendor</small>, dataIndex: 'vendor', key: 'vendor', render: (e) => {
                    return (e) ? e.name : "";
                }
            },
            {
                title: <small>Titles</small>, dataIndex: 'isbns_count', key: 'isbns_count'
            },
            // { title: <small>Cart</small>, dataIndex: 'cart_count', key: 'cart_count' },
            {
                title: <small>Posted</small>, dataIndex: 'date_posted', key: 'date_posted', render: (e, f) => {
                    return (
                        <>
                            <div><nobr>{moment(e * 1000).format("MMMDD-YY")}</nobr></div><div style={{ "color": "#999" }}>
                                {/* <em>{f.views} views</em> */}
                            </div>
                        </>
                    )
                }
            },
            {
                title: <small>Category</small>, dataIndex: 'category', key: 'category', render: (e, f) => {
                    return <><div style={{ "color": "#999" }}><em>{e}</em></div><div style={{ "fontWeight": "500", "maxWidth": "100px", "whiteSpace": "nowrap", "overflow": "hidden", "textOverflow": "ellipsis" }}>{f.owner_name}</div></>
                }
            },
            {
                title: <small>Season</small>, dataIndex: 'season', key: 'season', render: (e) => {
                    return (<nobr>{(e) ? e : ""}</nobr>);
                }
            },
            // {
            //     title: <small>Folder</small>, width: "160px", dataIndex: 'folder', key: 'folder', render: (e, f) => {
            //         return (
            //             <Space>
            //                 {/* <Bookmark link list_id={f.list_id} />
            //                 <ListTrash list={f} results={results} setResults={setResults} />
            //                 <ListArchive list={f} results={results} setResults={setResults} />
            //                 <ListFolder getLists={getLists} results={results.rows} setResults={setResults} folder={e} list_id={f.list_id} /> */}
            //             </Space>
            //         )
            //     }
            // }

        ]


        return (
            <div>
                <div style={{ minWidth: 'auto' }}>
                    <Table
                        rowKey="list_id"
                        size="small"
                        columns={columns}
                        className={"fullTable"}
                        dataSource={results.rows}
                        pagination={false}
                        expandable
                        expandedRowKeys={expanded}
                        expandIconColumnIndex={-1}
                        onExpand={(e) => { return false; }}
                        expandIcon={() => { return (<></>) }}
                        expandedRowRender={((record) => drawChildTable(record))}
                    />
                </div>
            </div>
        );
    }



    return (
        <div className="container" style={{"minHeight" : "calc(100vh - 450px)"}}>
            <div className="float-flex">
                <Space align="center"><Typography.Title style={{ "marginBottom": "6px" }} level={4}>Catalogues</Typography.Title><span style={{ "fontSize": "14px", "opacity": "0.8" }}>({results?.row_count ?? 0}) catalogues</span></Space>
                <div>
                    <Segmented onChange={(e) => setView(e)} value={view} size="small" options={[
                        {
                            value: 'details',
                            icon:
                                <Tooltip title="Detailed View">
                                    <PicLeftOutlined style={{ "fontSize": "13px" }} />
                                </Tooltip>,
                        },
                        {
                            value: 'list',
                            icon:
                                <Tooltip title="Brief View">
                                    <UnorderedListOutlined style={{ "fontSize": "13px" }} />
                                </Tooltip>,
                        }
                    ]}
                    />
                </div>
            </div>
            <Spin spinning={loading}>
                <div>
                    <div><BrowseFilters loading={loading} sort={
                        <Space>
                            <nobr>
                                <small>&nbsp;&nbsp;Sort:&nbsp;&nbsp;</small>
                                <Select
                                    value={filters.v}
                                    onChange={(value) => {
                                        history.push({ pathname: path + objectToPath({ ...filters, "v": value, "o": 0 }) });
                                    }}
                                    style={{ width: 150 }}
                                    className="asa-select"
                                    size="large"
                                    placeholder="Date posted"
                                >

                                    <Select.Option value="">Last updated</Select.Option>
                                    <Select.Option value="date_posted">Date Posted</Select.Option>
                                    <Select.Option value="name">Alphabetical</Select.Option>

                                </Select>
                            </nobr>
                        </Space>

                    } path={path} searchFilters={filters} setSearchFilters={setFilters} setFilters={setF} filters={f} /></div>
                    <div className="shim" />
                    <Divider style={{ "margin": "0px 0px" }} />
                    <Layout>
                        <Layout.Content style={{ "backgroundColor": "#fff" }}>
                            <div className="shim" /><div className="shim" />
                            <Paginate key={"paginate-1"} count={count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...filters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                            <Divider key={"divider-1"} dashed style={{ "margin": "10px 0px", "marginRight": "0px", "width": "auto", "minWidth": "auto" }} />

                            {(view === "details" && <div>{drawCatalogues()}</div>)}

                            {(view === "list" && <div>{drawCataloguesList()}</div>)}

                            <Divider key={"divider-2"} dashed style={{ "margin": "10px 20px", "marginRight": "0px", "width": "auto", "minWidth": "auto" }} />
                            <Paginate key={"paginate-2"} count={count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...filters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                        </Layout.Content>
                    </Layout>
                </div>
            </Spin>
        </div>
    )
}